<template>
  <a :href="url" @click="onClick()" class="result" :title="url" v-html="htmlText + categoryText"></a>
</template>

<script>
import { highlightMatches } from '@/utils/text';
import { categoryTranslationsMap } from './utils';
import { locationCategories } from '@/data/autocomplete/Location';

export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      default: '/',
    },
    category: {
      type: String,
      default: '',
      validator(value) {
        return !value || Object.keys(locationCategories).includes(value);
      },
    },
    searchText: {
      type: String,
      default: '',
    },
  },
  computed: {
    htmlText() {
      return highlightMatches(this.text, this.searchText).reduce(
        (prev, { highlighted, text }) => prev + (highlighted ? `<strong>${ text }</strong>` : text),
        '',
      );
    },
    categoryText() {
      return this.category ? ' - ' + this.$t(categoryTranslationsMap[this.category]) : '';
    },
  },
  methods: {
    onClick() {
      const clickedItem = {
        text: this.text + this.categoryText,
      };
      this.$emit('autocomplete-result-item-clicked', clickedItem);
      window.dispatchEvent(new CustomEvent('click-on-result-item'));
    },
  },
  emits: ['autocomplete-result-item-clicked'],
};
</script>

<style scoped lang="scss">
@import '@/scss/functions.scss';
@import '@/scss/variables.scss';

$item-color: #333;

.result {
  display: block;
  padding: rem-calc(8 0);
  font-size: rem-calc(15);
  line-height: rem-calc(16);

  &,
  &:visited:not(:hover) {
    text-decoration: none;
    color: $item-color;
  }

  &:hover {
    color: $cta-color;
  }
}

.result {
  text-transform: capitalize;
}
</style>
